import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class PalleteTypeService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	addPalletType(addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/export/asn/palletTypes/addPallet`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updatePalletType(updateObject): Observable<any> {
		/**
		* ${this.constantsService.baseAPIURL}
		* headers: this.constantsService.httpOptions
		*/
		return this.http.put(` ${this.constantsService.baseAPIURL}/export/asn/palletTypes/editPallet`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	loadDataPalletType(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/asn/palletTypes`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	deletePalletTypeData(palletTypeId): Observable<any> {

		return this.http
			.delete(`${this.constantsService.baseAPIURL}/export/asn/palletTypes/${palletTypeId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}



}
